var map = {
	"./arr-g.png": 528,
	"./arr-r.png": 529,
	"./arr-y.png": 530,
	"./high-left-2.png": 531,
	"./high-left-3.png": 532,
	"./high-left-4.png": 533,
	"./high-middle-2.png": 534,
	"./high-middle-3.png": 535,
	"./high-middle-4.png": 536,
	"./high-none-2.png": 537,
	"./high-none-3.png": 538,
	"./high-none-4.png": 539,
	"./high-right-2.png": 540,
	"./high-right-3.png": 541,
	"./high-right-4.png": 542,
	"./high-twoedge-2.png": 543,
	"./high-twoedge-3.png": 544,
	"./high-twoedge-4.png": 545,
	"./low-2.png": 546,
	"./low-3.png": 547,
	"./low-4.png": 548,
	"./middle-left-2.png": 549,
	"./middle-left-3.png": 550,
	"./middle-left-4.png": 551,
	"./middle-middle-2.png": 552,
	"./middle-middle-3.png": 553,
	"./middle-middle-4.png": 554,
	"./middle-none-2.png": 555,
	"./middle-none-3.png": 556,
	"./middle-none-4.png": 557,
	"./middle-right-2.png": 558,
	"./middle-right-3.png": 559,
	"./middle-right-4.png": 560,
	"./middle-twoedge-2.png": 561,
	"./middle-twoedge-3.png": 562,
	"./middle-twoedge-4.png": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;